import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import MedicalService from "../Services/MedicalService";
import { HSdecrypt } from "../utils/encryptPassword";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import profile from "../assets/images/ProfileImage.jpg";
import ChronicConditionService from "../Services/ChronicConditionService";
import { QRCodeCanvas } from "qrcode.react";
import { convertUTCDate } from "../utils/convertionFunc";
import { Flex, Spin } from "antd";
import PatientService from "../Services/PatientService";
import { FiDownload } from "react-icons/fi";
import { AiOutlineIdcard } from "react-icons/ai";
import EmcIcon from "../assets/images/Emcicon.png";
import Cardbg from "../assets/images/Cardbg.png";
import CardLogo from "../assets/images/Cardlogo.png";

function EmergencyDataView() {
  const frontRef = useRef();
  const backRef = useRef();
  const [patientQrData, setPatientQrData] = useState();
  const [patDetails, setPatDetails] = useState(null);
  const [chronicConditions, setChronicConditions] = useState([]);
  const [patientAlleryData, setPatientAlleryData] = useState([]);
  const [isLoading, setIsLoading] = useState({
    allergy: false,
    chronics: false,
    drug: false,
  });
  const [medications, setMedications] = useState([]);
  const [isFlipped, setIsFlipped] = useState(false);
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;

  useEffect(() => {
    PatientAllergies();
    PatientchronicConditions();
    patientMedication();
    getPatientDetails();
    PatientEmergencyData();
  }, []);

  const getPatientDetails = async () => {
    const payload = { patientId: loggedUser.patientId };
    try {
      const response = await PatientService.HSPatientData(payload);
      setPatDetails(response.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const PatientAllergies = () => {
    setIsLoading((prev) => ({ ...prev, allergy: true }));
    MedicalService.HSPatientAllergyList({ patientCode: loggedUser.patientId, status: 1 })
      .then((result) => {
        const parsed = JSON.parse(HSdecrypt(result.data.data));
        setPatientAlleryData(parsed?.map((item) => ({ drugAllergy: item["drugAllergy"] })));
        setIsLoading((prev) => ({ ...prev, allergy: false }));
      })
      .catch(() => setIsLoading((prev) => ({ ...prev, allergy: false })));
  };

  const PatientchronicConditions = () => {
    setIsLoading((prev) => ({ ...prev, chronics: true }));
    ChronicConditionService.HSPatientchronicConditions({ patientId: loggedUser.patientId })
      .then((result) => {
        setChronicConditions(JSON.parse(HSdecrypt(result.data.data)));
        setIsLoading((prev) => ({ ...prev, chronics: false }));
      })
      .catch(() => setIsLoading((prev) => ({ ...prev, chronics: false })));
  };

  const patientMedication = () => {
    setIsLoading((prev) => ({ ...prev, drug: true }));
    MedicalService.HSPatientMedication({ patientCode: loggedUser.patientId, status: 1 })
      .then((result) => {
        setMedications(JSON.parse(HSdecrypt(result.data.data)));
        setIsLoading((prev) => ({ ...prev, drug: false }));
      })
      .catch(() => setIsLoading((prev) => ({ ...prev, drug: false })));
  };

  const handleDownload = async () => {
    const pdf = new jsPDF();
    const frontSide = frontRef.current;
    const backSide = backRef.current;
    if (!frontSide || !backSide) return;
    try {
      backSide.style.display = "none";
      const frontCanvas = await html2canvas(frontSide, { scale: 3, useCORS: true });
      const frontImage = frontCanvas.toDataURL("image/png");

      frontSide.style.display = "none";
      backSide.style.display = "block";
      backSide.style.transform = "none";
      backSide.style.backfaceVisibility = "visible";
      const backCanvas = await html2canvas(backSide, { scale: 3, useCORS: true });
      const backImage = backCanvas.toDataURL("image/png");

      frontSide.style.display = "block";
      backSide.style.display = "none";

      const imgWidth = 180;
      const frontHeight = (frontCanvas.height * imgWidth) / frontCanvas.width;
      const backHeight = (backCanvas.height * imgWidth) / backCanvas.width;
      pdf.addImage(frontImage, "PNG", 10, 10, imgWidth, frontHeight);
      pdf.addImage(backImage, "PNG", 10, 20 + frontHeight, imgWidth, backHeight);
      pdf.save("Emergency_MedicalCard.pdf");
    } finally {
      frontSide.style.display = "block";
      backSide.style.display = "block";
      backSide.style.transform = "rotateY(180deg)";
      backSide.style.backfaceVisibility = "hidden";
    }
  };

  const calculateAge = (dob) => {
    const dobYear = dob?.split("/")[2];
    return dobYear ? new Date().getFullYear() - Number(dobYear) : "";
  };

  const PatientEmergencyData = () => {
    let patientDataV = JSON.parse(localStorage.getItem("patientData") || "null");
    MedicalService.PatientQrList({ status: 1, patientId: patientDataV?.patientId }).then((result) => {
      if (result?.data[0]?.healthCardUrl) {
        setPatientQrData("https://doctor-dev.doxzon.com/emergencyqr/" + result.data[0].healthCardUrl);
      }
    });
  };

  const handleCardClick = () => setIsFlipped((prev) => !prev);

  const isAnyLoading = isLoading.allergy || isLoading.chronics || isLoading.drug || !patDetails;

  return (
    <>
      {/* Scoped styles */}
      <style>{`
        .emc-wrapper {
          width: 100%;
          box-sizing: border-box;
        }

        /* Card scene */
        .emc-scene {
          width: 100%;
          /* Responsive height: clamp between 220px (mobile) and 260px (desktop) */
          height: clamp(220px, 55vw, 260px);
          perspective: 1200px;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;
        }

        .emc-card-inner {
          position: relative;
          width: 100%;
          height: 100%;
          transform-style: preserve-3d;
          transition: transform 0.7s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .emc-card-inner.flipped {
          transform: rotateY(180deg);
        }

        /* Front & Back share */
        .emc-face {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          border-radius: 12px;
          overflow: hidden;
          border: 2px solid #e2e8f0;
          box-sizing: border-box;
        }

        /* ---- FRONT ---- */
        .emc-front {
          background: #fff;
          display: flex;
          flex-direction: column;
        }

        .emc-front-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          height: 44px;
          flex-shrink: 0;
          background-image: url(${Cardbg});
          background-size: cover;
          background-position: center;
          border-radius: 10px 10px 0 0;
        }

        .emc-front-header p {
          font-size: clamp(11px, 3vw, 14px);
          font-weight: 600;
          color: #fff;
          margin: 0;
        }

        .emc-front-header img {
          height: clamp(24px, 5vw, 32px);
          object-fit: contain;
        }

        /* Body row */
        .emc-body {
          display: flex;
          flex: 1;
          padding: clamp(6px, 2vw, 10px);
          gap: clamp(6px, 2vw, 12px);
          align-items: center;
          overflow: hidden;
        }

        .emc-left {
          display: flex;
          gap: clamp(6px, 2vw, 14px);
          align-items: center;
          flex: 1;
          min-width: 0;
        }

        .emc-avatar {
          width: clamp(64px, 16vw, 88px);
          height: clamp(64px, 16vw, 88px);
          border-radius: 10px;
          border: 1.5px solid #e2e8f0;
          overflow: hidden;
          flex-shrink: 0;
          background: #f1f5f9;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .emc-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .emc-info {
          flex: 1;
          min-width: 0;
        }

        .emc-info-row {
          font-size: clamp(10px, 2.6vw, 13px);
          color: #5c5c5c;
          margin: 0 0 clamp(2px, 0.8vw, 5px) 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .emc-info-row span {
          font-weight: 700;
          color: #333;
        }

        .emc-info-row span.blue {
          color: #197ebc;
        }

        .emc-qr-box {
          width: clamp(64px, 16vw, 88px);
          height: clamp(64px, 16vw, 88px);
          border-radius: 8px;
          border: 1.5px solid #e2e8f0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: #fff;
        }

        /* Footer bar */
        .emc-footer {
          height: 38px;
          background: #002b42;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: clamp(6px, 2vw, 12px);
          border-radius: 0 0 10px 10px;
          flex-shrink: 0;
        }

        .emc-emergency-badge {
          background: #ef5050;
          border-radius: 6px;
          padding: 2px 8px;
          color: #fff;
          font-size: clamp(9px, 2.4vw, 12px);
          font-weight: 600;
          white-space: nowrap;
        }

        .emc-footer-contact {
          font-size: clamp(9px, 2.4vw, 12px);
          font-weight: 500;
          color: #fff;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 55%;
        }

        .emc-footer-contact span {
          font-size: clamp(10px, 2.6vw, 13px);
          font-weight: 700;
        }

        /* ---- BACK ---- */
        .emc-back {
          background: #002b42;
          transform: rotateY(180deg);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .emc-back-body {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: clamp(10px, 3vw, 24px) clamp(12px, 4vw, 24px);
          text-align: center;
        }

        .emc-back-body p {
          font-size: clamp(11px, 2.8vw, 14px);
          font-weight: 600;
          color: #fff;
          margin: 0 0 6px 0;
          line-height: 1.4;
        }

        .emc-back-body a {
          font-size: clamp(10px, 2.5vw, 13px);
          font-weight: 700;
          color: #189faa;
          text-decoration: underline;
          word-break: break-all;
        }

        .emc-back-footer {
          height: 40px;
          background: #f8fafc;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: clamp(6px, 2vw, 10px);
          border-top: 1px solid #e2e8f0;
          border-radius: 0 0 10px 10px;
          flex-shrink: 0;
        }

        .emc-member-badge {
          background: #0aa0ac;
          color: #fff;
          font-size: clamp(10px, 2.5vw, 13px);
          font-weight: 600;
          border-radius: 6px;
          padding: 3px 10px;
          white-space: nowrap;
        }

        .emc-back-footer-id {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: clamp(10px, 2.5vw, 13px);
          color: #333;
          white-space: nowrap;
        }

        .emc-back-footer-id span {
          font-weight: 700;
        }

        /* Download button */
        .emc-download-btn {
          width: 28px;
          height: 28px;
          background: rgba(255,255,255,0.15);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border: 1.5px solid rgba(255,255,255,0.3);
          transition: background 0.2s;
          flex-shrink: 0;
          padding: 0;
        }

        .emc-download-btn:hover {
          background: rgba(255,255,255,0.28);
        }

        /* Loading */
        .emc-loading {
          height: 220px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Flip hint */
        .emc-hint {
          font-size: 10px;
          color: #94a3b8;
          text-align: center;
          margin-top: 5px;
          user-select: none;
        }
      `}</style>

      <div className="emc-wrapper">
        {isAnyLoading ? (
          <div className="emc-loading">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : (
          <>
            {/* Card scene */}
            <div className="emc-scene" onClick={handleCardClick}>
              <div className={`emc-card-inner ${isFlipped ? "flipped" : ""}`}>

                {/* ---- FRONT FACE ---- */}
                <div className="emc-face emc-front" ref={frontRef}>
                  <div className="emc-front-header">
                    <p>Emergency Medical Card</p>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <img src={CardLogo} alt="Logo" />
                      <button
                        className="emc-download-btn"
                        onClick={(e) => { e.stopPropagation(); handleDownload(); }}
                        title="Download PDF"
                      >
                        <FiDownload style={{ color: "#ffffff", width: 14, height: 14 }} />
                      </button>
                    </div>
                  </div>

                  <div className="emc-body">
                    <div className="emc-left">
                      {/* Avatar */}
                      <div className="emc-avatar">
                        <img
                          src={
                            patDetails?.photoNameBase64
                              ? "data:image/jpeg;base64," + patDetails.photoNameBase64
                              : profile
                          }
                          alt="Patient"
                        />
                      </div>

                      {/* Info */}
                      <div className="emc-info">
                        <p className="emc-info-row">
                          Name:{" "}
                          <span className="blue">
                            {[patDetails?.salutation, patDetails?.firstName, patDetails?.lastName]
                              .filter(Boolean)
                              .join(" ")}
                          </span>
                        </p>
                        <p className="emc-info-row">
                          Age: <span>{calculateAge(patDetails?.ageDob)}</span>
                        </p>
                        <p className="emc-info-row">
                          Blood Group: <span>{patDetails?.bloodGroup}</span>
                        </p>
                        <p className="emc-info-row">
                          Mobile No: <span>{patDetails?.mobile}</span>
                        </p>
                      </div>
                    </div>

                    {/* QR */}
                    <div className="emc-qr-box">
                      {patientQrData && (
                        <QRCodeCanvas value={patientQrData} size={56} />
                      )}
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="emc-footer">
                    <span className="emc-emergency-badge">Emergency</span>
                    <span className="emc-footer-contact">
                      Mobile Number:{" "}
                      <span>{patDetails?.emergencyContact}</span>
                    </span>
                  </div>
                </div>

                {/* ---- BACK FACE ---- */}
                <div className="emc-face emc-back" ref={backRef}>
                  <div className="emc-back-body">
                    <p>Access my personal Health Records At:</p>
                    <a
                      href={`${process.env.REACT_APP_FRONTEND_URL?.replace(/\/$/, "")}/PHR-ACCESS/${patDetails?.patientId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {`${process.env.REACT_APP_FRONTEND_URL?.replace(/^https?:\/\//, "")}/PHR-ACCESS`}
                    </a>
                  </div>

                  <div className="emc-back-footer">
                    <span className="emc-member-badge">Member ID</span>
                    <div className="emc-back-footer-id">
                      <AiOutlineIdcard style={{ width: 18, height: 18 }} />
                      <span>ID No:</span>
                      <span>{patDetails?.patientId}</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <p className="emc-hint">Tap card to flip</p>
          </>
        )}
      </div>
    </>
  );
}

export default EmergencyDataView;
